
<div class="shop-edit contents">
  <div v-if="form.hasErrors()" class="ui warning message">入力エラー</div>
  <div class="ui pointing secondary menu">
    <a class="item" data-tab="basic">基本情報</a>
    <a class="item" data-tab="photo">写真</a>
    <a class="item" data-tab="menu">メニュー</a>
    <a class="item" data-tab="room">会場</a>
    <a class="item" data-tab="facility">設備</a>
    <a class="item" data-tab="additional_condition">詳細情報</a>
    <a v-if="isStaff" class="item" data-tab="account">ログイン情報</a>
  </div>

  <basic-tab :form="form" @save="save()"></basic-tab>
  <photo-tab ref="photoTab"></photo-tab>
  <menu-tab ref="menuTab"></menu-tab>
  <room-tab ref="roomTab"></room-tab>
  <facility-tab ref="facilityTab"></facility-tab>
  <additional-condition-tab ref="additionalConditionTab"></additional-condition-tab>
  <account-tab v-if="isStaff" ref="accountTab"></account-tab>

</div>
